<mat-tab-group class="data-collection-tab" (selectedIndexChange)="selectTab($event)">
    <mat-tab label="Drill Data Details">
        <app-drill-data-collection-view [type]="'drillData'" [active]="selectedTabIndex === 0"></app-drill-data-collection-view>
    </mat-tab>
    <mat-tab label="Blast Data Details">
        <app-drill-data-collection-view [type]="'blastData'" [active]="selectedTabIndex === 1"></app-drill-data-collection-view>
    </mat-tab>
    <mat-tab label="Fielder Data Details">
        <app-drill-data-collection-view [type]="'fielderData'" [active]="selectedTabIndex === 2"></app-drill-data-collection-view>
    </mat-tab>
    <mat-tab label="Drill Shift Details">
        <app-drill-shift-details-collection-view [active]="selectedTabIndex === 3"></app-drill-shift-details-collection-view>
    </mat-tab>
</mat-tab-group>
